angular.module('App.MyAccount.Profile.Ctrl', [
    'jv.Common.Modal',
    'jv.ImageCropper',
    'jv.Common.Directives.ImageUploader',
    'App.MyAccount.Profile.SVC',
    'App.MyAccount.AlternateApprover.Ctrl',
    'App.MyAccount.OutOfOffice.Ctrl',
    'jv.Common.ScrollIntoView'
])
.controller('ProfileCtrl', ['$rootScope', '$scope', 'myAccount', '$log', '$window', '$filter', function($rootScope, $scope, myAccount, $log, $window, $filter){
    $scope.changedLanguageModal = {
        close: function(){
            $scope.myAccount.userPreferences.isLanguageTagNotSupported = false;
        },
        editLanguage: function(){
            this.close();
            $scope.myAccount.regionLanguageDate.edit = true;
            $scope.$emit('scrollIntoView');
        },
        saveLanguage: function(){
            this.close();
            $scope.saveRegionLanguageDetails();
        }
    };

    $rootScope.breadcrumbsConfig = {
        links:[
             {
                 linkText: i18n['PROFILE'],
                 link: $scope.jvUrls.admin+'/myaccount/profile.html#/'
             }
         ],
         backText: i18n['GO_BACK_TO'],
         previousText: i18n['PREVIOUS'],
         menuText: i18n['MENU']
    };

    $scope.myAccount = $scope.myAccount || {};
    $scope.showBasicSettings = true;

    if($scope.myAccount.profilePic){
        $scope.myAccount.profilePic.invalidImageType = false;
        $scope.myAccount.profilePic.fileSizeExceeded = false;
    }

    $('body').on('click', function(e){
        var target = $(e.target);

        if (target.parents('.profile_avatar').length < 1 && target.attr('class') !== 'profile_avatar'){
            $scope.myAccount.showTooltip = false;
            $scope.$apply();
        }
    });

    var mapTimeZone = function(timezones){
        var timezoneMap = {};
        for(var index in timezones){
            var timeZone = timezones[index];
            timezoneMap[timeZone.id] = timeZone;
        }
        return timezoneMap;
    };

    var normalizeDetails = function(obj){
        for(var i in obj.user){
            obj.user[i] = $filter('trim')(obj.user[i]);
        }
        $scope.myAccount.details = obj;
        $scope.myAccount.userCopy = angular.copy(obj.user);
    };

    var getProfileDetails = function(){
        $scope.flags.loading = true;
        myAccount.getProfileDetails(function(res){
            $scope.flags.loading = false;
            normalizeDetails(res);
        }, function(err){
            $scope.flags.loading = false;
            $log.error(err);
        });
    };

    var getAdditionalInfo = function(){
        $scope.flags.loading = true;
        myAccount.getAdditionalInfo(function(res){
            $scope.flags.loading = false;
            $scope.myAccount.additionalInfo = res;
            $scope.myAccount.additionalInfoCopy = angular.copy(res);
            $scope.myAccount.additionalInfo.timezoneMap = mapTimeZone($scope.myAccount.additionalInfo.allTimezones);
        }, function(err){
            $scope.flags.loading = false;
            $log.error(err);
        });
    };

    var getRegionLocationDetails = function(){
        $scope.flags.loading = true;
        myAccount.getLanguageDateInfo(function(res){
            $scope.flags.loading = false;
            $scope.myAccount.regionLanguageDate = res;
            //this is used to reset when user hits cancel
            $scope.myAccount.regionLanguageDateCopy = angular.copy($scope.myAccount.regionLanguageDate);
            if(res && res.user){
                $scope.myAccount.userPreferences = angular.copy(res.user.localizationPreferences);
            }
        }, function(err){
            $scope.flags.loading = false;
            $log.error(err);
        });
    };
    
    //cancel regional preference edit
    $scope.cancelRegionalPreferenceEdit = function(){
        $scope.myAccount.regionLanguageDate.edit = false;
        $scope.myAccount.regionLanguageDate  = angular.copy($scope.myAccount.regionLanguageDateCopy);
    };

    var getProfilePic = function(){
        $scope.myAccount.profilePic = $scope.myAccount.profilePic || {};
        $scope.myAccount.profilePic.imageURL = '/admin/action/myAccount/profilePhoto?size=m';
    };

    var showProfilePicInModal = function(fileName){
        $scope.myAccount.profilePic.uploadedPic = '/admin/action/myAccount/cropProfilePhoto?_='+new Date().getTime();
        $scope.myAccount.profilePic.fileName = fileName;
        $scope.myAccount.profilePic.showModal = true;
    };

    var validatePassword = function(password){
        var pattern=/^.*(?=.{8,})(?=.*\d)(?=.*[a-z])(?=.*[A-Z]).*$/;
        if($scope.myAccount.details.topCoSSOEnabled){
            pattern=/^.*(?=.{9,})(?=.*\d)(?=.*[a-z])(?=.*[A-Z]).*$/;
        }
        var oneUpCase=/[A-Z]/;
        var oneLowerCase=/[a-z]/;
        var oneNum=/[0-9]/;
        var isValid = true;
        if(password && !password.match(pattern)){
            isValid = false;
            if((!$scope.myAccount.details.topCoSSOEnabled && password.length < 8) || ($scope.myAccount.details.topCoSSOEnabled && password.length < 9)){
                $scope.myAccount.password.newPassLengthError = true;
            }else if(!password.match(oneUpCase)){
                $scope.myAccount.password.newPassUpperCaseError = true;
            }else if(!password.match(oneLowerCase)){
                $scope.myAccount.password.newPassLowerCaseError = true;
            }else if(!password.match(oneNum)){
                $scope.myAccount.password.newPassNumberError = true;
            }else{
                $scope.myAccount.password.newPassPatternError = true;
            }
        }

        if($scope.myAccount.password && ($scope.myAccount.password.reTypeNew !== $scope.myAccount.password.newPass)){
            isValid = false;
            $scope.myAccount.password.reTypeNewError = true;
        }

        return isValid;
    };

    var cleanUplaoder = function(divId){
        $('#'+divId+' ul.qq-upload-list').find('li').remove();
        $('#'+divId+' .qq-upload-button').show();
        $('#'+divId+' .qq-upload-instruction').show();
    };

    var init = function(triggerGetProfile, triggerAdditionalInfo, triggerProfilePic, triggerRegionLocationDetails){
        $scope.flags.loading = true;

        if(triggerGetProfile){
            getProfileDetails();
        }

        if(triggerAdditionalInfo){
            getAdditionalInfo();
        }

        if(triggerProfilePic){
            getProfilePic();
        }

        if(triggerRegionLocationDetails){
            getRegionLocationDetails();
        }

        myAccount.getCountries(function(res){
            $scope.myAccount.countries = res;
        }, function(err){
            $log.error(err);
        });
    };

    $scope.uploadFile = function(){
        var cropData = $scope.myAccount.profilePic.croppedData;
        var fileData = $scope.myAccount.profilePic.fileData;

        if(fileData && cropData){
            $scope.flags.loading = true;

            myAccount.uploadProfilePicture(fileData, cropData, function(){
                $scope.hideModal();
                cleanUplaoder('picUploader');
                $scope.showMsg('DATA_SAVED');
                $scope.myAccount.profilePic.imageURL = '/admin/action/myAccount/profilePhoto?size=m&_='+new Date().getTime();
                $('#hr-profilePic > img').attr('src', $('#hr-profilePic > img').attr('src')+'&_='+Math.random());
                $('#picUploader').val('');
                $scope.flags.loading = false;
            }, function(err){
                $log.error(err);
            });
        }
    };

    $scope.cancelJsDetails = function(){
        $scope.myAccount.details.user = angular.copy($scope.myAccount.userCopy);
        $scope.myAccount.details.edit = false;
    };

    $scope.editProfileDetails = function(){
        if($scope.myAccount.countries){
            for(var i=0; i<$scope.myAccount.countries.resultList.length ;i++){
                if($scope.myAccount.countries.resultList[i].country === $scope.myAccount.details.user.country){
                    $scope.myAccount.details.user.countryObj = $scope.myAccount.countries.resultList[i];
                    break;
                }
            }
        }

        $scope.myAccount.details.edit = true;
    };

    $scope.changeCountry = function(obj){
        if(obj){
            $scope.myAccount.details.user.country = obj.country;
        }
    };

    $scope.saveJsDetails = function(user){
        if(!$scope.myAccount.details.user.firstName || $scope.myAccount.details.user.firstName.trim().length === 0 || !$scope.myAccount.details.user.lastName || $scope.myAccount.details.user.lastName.trim().length === 0){
            return;
        }
        var data = {
            firstName: user.firstName,
            lastName: user.lastName,
            title: user.title,
            address: user.address,
            address2: user.address2,
            city: user.city,
            state: user.state,
            postalCode: user.postalCode,
            zip: isNaN(user.postalCode)? 0: user.postalCode.trim().length === 0? 0 : user.postalCode,
            country: user.country,
            mobile: user.mobile,
            homePhone: user.homePhone,
            workPhone: user.workPhone,
            fax: user.fax
        };

        $scope.flags.loading = true;
        myAccount.saveProfileDetails(data, function(res){
            $scope.flags.loading = false;
            if(res.msgInfo === 200){
                $scope.showMsg('DATA_SAVED');
            }
            getProfileDetails();
        }, function(err){
            $log.error(err);
            $scope.flags.loading = false;
        });
    };

    $scope.saveAdditionalInfo = function(){
        var tempData = angular.copy($scope.myAccount.additionalInfo);
        $scope.flags.loading = true;
        myAccount.saveAdditionalInfo(tempData.user, function(res){
            if(res.msgInfo === 200){
                $scope.showMsg('MYACCOUNT_INFORMATION_UPDATED');
                $scope.refreshUserSession(false);
                init(false, true, false);
            }else{
                $rootScope.error = $scope.i18n.errors['UNABLE_TO_PERFORM'];
            }
            $scope.flags.loading = false;
        }, function(err){
            $scope.flags.loading = false;
            $log.error(err);
        });
    };

    $scope.cancelInfo = function(){
        $scope.myAccount.additionalInfo = angular.copy($scope.myAccount.additionalInfoCopy);
        $scope.myAccount.additionalInfo.timezoneMap = mapTimeZone($scope.myAccount.additionalInfo.allTimezones);
    };

    $scope.validateCurrentPassword = function(pass){
        var data = {
            currentPassword: pass
        };
        if(!$scope.myAccount.details.topCoSSOEnabled){
            myAccount.validateCurrentPassword(data, function(res){
                if(res && res.msgInfo && res.msgInfo === 409){
                    $scope.myAccount.password.currentError = true;
                }else if(res && res.msgInfo && res.msgInfo === 200){
                    $scope.myAccount.password.currentError = false;
                }
            }, function(err){
                $log.error(err);
            });
        }
    };

    $scope.validateReTypePassword = function(passwordObj){
        if(passwordObj && (passwordObj.reTypeNew === passwordObj.newPass)){
            $scope.myAccount.password.reTypeNewError = false;
        }else{
            $scope.myAccount.password.reTypeNewError = true;
        }
    };

    $scope.saveNewPassword = function(){
        $scope.flags.loading = true;
        var data = angular.copy($scope.myAccount.password);
        $scope.myAccount.password.newPassLengthError = false;
        $scope.myAccount.password.newPassLowerCaseError = false;
        $scope.myAccount.password.newPassUpperCaseError = false;
        $scope.myAccount.password.newPassNumberError = false;
        $scope.myAccount.password.newPassPatternError = false;
        $scope.myAccount.password.cannotUseOldPassword = false;

        if(($scope.myAccount.details.topCoSSOEnabled || !data.currentError) && !data.reTypeNewError){
            var valid = validatePassword(data.newPass);
            if(valid){
                data.currentPassword = data.current;
                data.newPassword = data.newPass;
                myAccount.updatePassword(data, function(res){
                    $scope.flags.loading = false;
                    //Logout action should be performed after password is changed successfully.
                    if(res.msgInfo === 200 && angular.isFunction(window.logoutFromJobvite)){
                        window.logoutFromJobvite(res.logoutUrl);
                    } else if(res.msgInfo === 406){
                        $scope.myAccount.password.cannotUseOldPassword = true;
                    }else if(res.msgInfo === 409){
                        $scope.myAccount.password.currentError = true;
                    }else{
                        $rootScope.error = $scope.i18n.errors['UNABLE_TO_PERFORM'];
                    }
                }, function(err){
                    $scope.flags.loading = false;
                    $log.error(err);
                });
            }
        }

        $scope.flags.loading = false;
    };

    $scope.openChangeEmailModal = function(){
        $scope.myAccount.email = $scope.myAccount.email || {};
        $scope.myAccount.email.edit = true;
    };

    $scope.saveNewEmail = function(){
        $scope.myAccount.email.patternErr = false;
        $scope.myAccount.email.sameEmailErr = false;
        $scope.myAccount.email.emptyEmailErr = false;

        var str = [];

        if(!$scope.myAccount.email.newVal || $scope.myAccount.email.newVal.trim().length === 0){
            $scope.myAccount.email.emptyEmailErr = true;
            return;
        }

        if($scope.myAccount.email.newVal && $scope.myAccount.details.user.email && $scope.myAccount.email.newVal.toLowerCase() === $scope.myAccount.details.user.email.toLowerCase()){
            $scope.myAccount.email.sameEmailErr = true;
            return;
        }

        str = $scope.myAccount.email.newVal.match(/[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*@(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?/g);

        if(str && str.length > 0 && str[0] === $scope.myAccount.email.newVal){
            $scope.flags.loading = true;
            myAccount.notifyChangeEmail($scope.myAccount.email.newVal, function(){
                $scope.flags.loading = false;
                $scope.resetEmail();
                $scope.showMsg('EMAIL_NOTIFIED');
            }, function(err){
                $scope.flags.loading = false;
                if(err.msgInfo){
                    $rootScope.error = $scope.i18n.errors[err.msgInfo];
                }
            });
        }else{
            $scope.myAccount.email.patternErr = true;
        }
    };

    $scope.resetEmail = function(){
        $scope.myAccount.email.edit = false;
        $scope.myAccount.email.newVal = '';
        $scope.myAccount.email.patternErr = false;
        $scope.myAccount.email.sameEmailErr = false;
        $scope.myAccount.email.emptyEmailErr = false;
    };

    $scope.resetPassword = function(){
        var options = {
            edit: false,
            newPassLengthError: false,
            newPassLowerCaseError: false,
            newPassUpperCaseError: false,
            newPassNumberError: false,
            reTypeNewError: false,
            cannotUseOldPassword: false,
            currentError: false,
            current: '',
            newPass: '',
            reTypeNew: ''
        };

        for(var i in options){
            $scope.myAccount.password[i] = options[i];
        }

        $scope.myAccount.password.edit = false;
    };

    $scope.saveProfilePic = function(){
        $scope.flags.loading = true;
        var data = {
            pictureDetails: angular.copy($scope.myAccount.profilePic.croppedData)
        };

        data.pictureDetails.fileName = angular.copy($scope.myAccount.profilePic.fileName);

        myAccount.saveProfilePicture(data.pictureDetails, function(response){
            $scope.hideModal();
            cleanUplaoder('picUploader');
            if (response.msgInfo === 200) {
                $scope.showMsg('DATA_SAVED');
                $scope.myAccount.profilePic.imageURL = '/admin/action/myAccount/profilePhoto?size=m&_='+new Date().getTime();
                $('#hr-profilePic > img').attr('src', $('#hr-profilePic > img').attr('src')+'&_='+Math.random());
            }else{
                $rootScope.error = $scope.i18n.errors['UNABLE_TO_PERFORM'];
            }
            $scope.flags.loading = false;
        }, function(err){
            $scope.hideModal();
            $log.error(err);
        });
    };

    $scope.hideModal = function(){
        $scope.myAccount.profilePic.showModal = false;
        delete $scope.myAccount.profilePic.uplodedFile;
        cleanUplaoder('picUploader');
    };

    if($scope.isIE()){
        $scope.$watch('myAccount.profilePic.uplodedFile', function(newValue){
            if(!$.isEmptyObject(newValue)){
                if(newValue.picInfo.uploaded){
                    showProfilePicInModal(newValue.picInfo.fileName);
                }
            }
        }, true);
    }

    $scope.deleteProfilePicture = function(){
        $scope.flags.loading = true;
        myAccount.deleteProfilePicture(function(){
            $scope.flags.loading = false;
            $scope.myAccount.showTooltip = false;
            $('#hr-profilePic > img').attr('src', $('#hr-profilePic > img').attr('src')+'&_='+Math.random());
            $scope.myAccount.profilePic.imageURL = '/admin/action/myAccount/profilePhoto?size=m&_='+new Date().getTime();
            $scope.showMsg('PICTURE_DELETED');
        }, function(err){
            $log.error(err);
        });
    };

    $scope.saveRegionLanguageDetails = function(){
            $scope.flags.loading = true;
            myAccount.saveRegionLanguageDetails($scope.myAccount.regionLanguageDate.user.localizationPreferences, function(){
                $scope.flags.loading = false;
                $scope.refreshUserSession(true);  //reloading page once language or date settings are changed
            }, function(err){
                $log.error(err);
            });
    };

    $scope.refreshUserSession = function(isForceReload){
        myAccount.refreshUserSession();
        if(isForceReload){
            $window.location.reload();
        }
    };
    
    $scope.setDistanceUnit=function(){
        if($scope.myAccount.regionLanguageDate.user.localizationPreferences.languageTag==='en-US'){
            $scope.myAccount.regionLanguageDate.user.localizationPreferences.unitOfDistance = 'MILE' ;
        } else {
            $scope.myAccount.regionLanguageDate.user.localizationPreferences.unitOfDistance = 'KILOMETER';
        }
    };

    init(true, true, true, true);
}]);
